'use client';

import { useState, FormEvent } from 'react';
import Link from 'next/link';
import Image from 'next/image';
import { clienteApi } from '@/services/clienteApi';

export default function ForgotPasswordPage() {
    const [email, setEmail] = useState('');
    const [isLoading, setIsLoading] = useState(false);
    const [message, setMessage] = useState('');
    const [error, setError] = useState('');

    const handleSubmit = async (e: FormEvent) => {
        e.preventDefault();
        setIsLoading(true);
        setError('');
        setMessage('');

        try {
            const res = await clienteApi.crudo('/api/auth/forgot-password', {
                method: 'POST',
                cuerpo: { email },
            });

            const data = await res.json();

            if (res.ok) {
                setMessage(data.message);
                setEmail(''); // Limpiar input para evitar reenvíos accidentales
            } else {
                setError(data.message || 'Error al procesar solicitud');
            }
        } catch (err) {
            setError('Error de conexión. Inténtalo más tarde.');
        } finally {
            setIsLoading(false);
        }
    };

    return (
        <div className="flex min-h-screen bg-canvas landing-grid flex-col items-center justify-center p-4">
            {/* --- LOGO --- */}
            <Link
                href="/"
                className="mb-8 w-full max-w-md transition-transform hover:scale-105 hover:opacity-90 flex justify-center"
            >
                <div className="relative w-full h-48">
                    <Image
                        src="/THERAPY(2).svg"
                        alt="TherapyRecap Logo"
                        fill
                        className="object-contain dark:invert" // Ajusta al contenedor sin deformarse
                        priority
                    />
                </div>
            </Link>

            <div className="w-full max-w-md bg-surface-2 p-8 rounded-3xl shadow-[8px_8px_0px_0px_var(--shadow-color)] border-2 border-ink">
                <div className="text-center mb-8">
                    <h1 className="text-2xl font-bold text-ink mb-2">
                        Recuperar Contraseña
                    </h1>
                    <p className="text-ink/80 text-sm font-medium">
                        Ingresa tu email y te enviaremos instrucciones
                    </p>
                </div>

                {message ? (
                    <div className="p-4 bg-tint-success-strong border-2 border-success text-on-tint-success text-sm rounded-xl font-bold text-center mb-6 shadow-[4px_4px_0px_0px_#16a34a]">
                        <p>{message}</p>
                        <div className="mt-4">
                            <Link href="/app/login" className="text-ink hover:underline font-bold">
                                Volver al inicio de sesión
                            </Link>
                        </div>
                    </div>
                ) : (
                    <form onSubmit={handleSubmit} className="space-y-5">
                        {error && (
                            <div className="p-3 bg-tint-danger-strong border-2 border-danger text-on-tint-danger text-sm rounded-xl font-bold text-center shadow-[4px_4px_0px_0px_#ef4444]">
                                {error}
                            </div>
                        )}
                        <div>
                            <label className="block text-xs font-bold text-ink mb-1.5 uppercase tracking-wider">
                                Email Profesional
                            </label>
                            <input
                                type="email" required value={email} onChange={(e) => setEmail(e.target.value)}
                                className="w-full bg-surface-2 border-2 border-ink text-ink rounded-xl px-4 py-3 focus:outline-none focus:ring-2 focus:ring-ink/20 focus:border-ink transition-all placeholder:text-ink/40 font-medium"
                                placeholder="tu@email.com"
                            />
                        </div>
                        <button type="submit" disabled={isLoading} className="w-full bg-ink text-canvas border-2 border-ink hover:bg-ink/90 font-bold py-3 rounded-xl shadow-[4px_4px_0px_0px_var(--shadow-color)] hover:translate-y-0.5 hover:shadow-[2px_2px_0px_0px_var(--shadow-color)] active:translate-y-1 active:shadow-none transition-all duration-200 disabled:opacity-50 disabled:cursor-not-allowed flex justify-center items-center">
                            {isLoading ? <span className="material-symbols-outlined animate-spin text-xl" aria-hidden="true">progress_activity</span> : 'Enviar Instrucciones'}
                        </button>
                    </form>
                )}

                {!message && (
                    <div className="mt-6 text-center text-sm text-ink/80 font-medium">
                        <Link href="/app/login" className="text-ink font-bold hover:underline transition-all">
                            Volver al inicio de sesión
                        </Link>
                    </div>
                )}
            </div>
        </div>
    );
}
